const slugify = (text) => {
  const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;-';
  const to = 'aaaaaeeeeeiiiiooooouuuunc_______';

  const newText = text.split('').map(
    (letter, i) => letter.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i)),
  );

  return newText
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/&/g, '_y_')
    .replace(/[^\w-]+/g, '')
    .replace(/-(-)+/g, '_');
};

export default slugify;
